import { render } from "./GrouperBanner.vue?vue&type=template&id=f309b0ea&scoped=true"
const script = {}

import "./GrouperBanner.vue?vue&type=style&index=0&id=f309b0ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f309b0ea"]])

export default __exports__
import QBar from 'quasar/src/components/bar/QBar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBar,QIcon});
